import React from 'react';
import T from 'i18n-react';

import DropDown, { DropDownPropTypes } from './components/DropDown';

const CostDropDown = ({ ...restProps }) => (
  <DropDown
    {...restProps}
    label={T.translate('new.costImpact')}
    valueKey="key"
    placeholder={T.translate('filter.costImpact')}
  />
);

// eslint-disable-next-line no-unused-vars
const { label, placeholder, valueKey, searchIcon, ...CostDropDownPropTypes } = DropDownPropTypes;

CostDropDown.propTypes = CostDropDownPropTypes;
export default CostDropDown;
